// extracted by mini-css-extract-plugin
export default {"overflow":"style_overflow__xxoeH"};